import { LogoIconV2 } from "@/assets/images";

const Header = () => (
  <div className="w-full flex justify-center items-center text-purple-3 pt-8 pb-6 md:pt-6">
    <div className="max-w-[150px]">
      <LogoIconV2 />
    </div>
  </div>
);

export { Header };
